module.exports = __webpack_public_path__ + "a_clockwork_orange.089e5514.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/a_clockwork_orange.jpg
// module id = gfKs
// module chunks = 0